export default __webpack_public_path__ + "static/media/img_modal_membership.a466d743.png";